import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import React from "react";

export const ContextMenu = ({
  items,
  event,
  onClose,
  clickedRow,
  copiedRow,
}) => {
  const state = {
    mouseX: event ? event.clientX - 2 : null,
    mouseY: event ? event.clientY - 4 : null,
  };

  return (
    <Menu
      keepMounted
      open={state.mouseY !== null}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        state.mouseY !== null && state.mouseX !== null
          ? { top: state.mouseY, left: state.mouseX }
          : undefined
      }
      onContextMenu={(event) => {
        event.preventDefault();
      }}
    >
      {items.map((item, index) => {
        if (copiedRow === null && index === items.length - 1) {
          return null;
        }
        return (
          <MenuItem
            key={index}
            onClick={() => {
              onClose();
              item.onClick(clickedRow);
            }}
          >
            {item.text}
          </MenuItem>
        );
      })}
    </Menu>
  );
};
